const BIND_BUTTONS =
    'document.querySelectorAll("[data-popup-action]").forEach(function(b){' +
    'b.addEventListener("click",function(){' +
    'var a=b.dataset.popupAction;if(a==="print"){print()}else if(a==="close"){close()}' +
    "})})";

/**
 * Wire up the `data-popup-action` Print and Close buttons in a print pop-up.
 *
 * The `about:blank` pop-up inherits its opener's CSP, which allows no inline
 * `onclick` handlers. Nor can the opener add the listeners itself: browsers
 * stop running them once the opener navigates away, and the pop-up outlives
 * the page that opened it. So the opener inserts a script that adds them from
 * inside the pop-up. `'strict-dynamic'` trusts it whatever its URL.
 */
export const bindPrintPopupButtons = (
    popup: Pick<Window, "document">,
): void => {
    const script = popup.document.createElement("script");
    script.src = `data:text/javascript,${encodeURIComponent(BIND_BUTTONS)}`;
    popup.document.body.append(script);
};
